<template>
  <div class="content">
    <div class="">
      <div class="row">
        <div class="col-md-12">
          <h3 class="card-title">
            <strong
              >{{ title }}
              <button
                type="button"
                class="btn btn-info btn-fill float-right"
                @click="goBack"
                style="
                  border-radius: 25px !important;
                  background: #651366 !important;
                "
              >
                <strong>Volver</strong>
              </button></strong
            >
          </h3>
          <div
           
          >
            

            <div class="card mx-1" style="width: 100%;">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-4">
                    <img
                      v-if="
                        form_update.vehicle.url_image != null &&
                        form_update.vehicle.url_image != undefined &&
                        form_update.vehicle.url_image != '' &&
                        form_update.vehicle.url_image != 'prueba'
                      "
                      class="card-img-top mx-auto d-block mt-2"
                      :src="form_update.vehicle.url_image"
                      onerror="this.onerror=null;src=this.default_img"
                      style="
                        height: 120px;
                        width: 120px;
                        text-align: center;
                        border-radius: 20px;
                      "
                    />
                    <img
                      v-else
                      class="card-img-top mx-auto d-block mt-2"
                      src="https://play-lh.googleusercontent.com/Fa-hPHOekHE_3QxlVqjlnz1SCnwEye8BAVsqcHX4tzFTdiY9hM6U1FO1hc1YyTYWh0o=s200"
                      style="
                        height: 150px;
                        width: 150px;
                        text-align: center;
                        border-radius: 20px;
                      "
                    />
                  </div>
                  <div class="col-md-4">
                    <h5 class="card-title" style="color: black !important">
                      <strong>Color: {{ form_update.vehicle.color }}</strong>
                    </h5>
                    <h5 class="card-title" style="color: black !important">
                      <strong>Modelo: {{ form_update.vehicle.name }}</strong>
                    </h5>
                    <h5 class="card-title" style="color: black !important">
                      <strong>Año: {{ form_update.vehicle.year }}</strong>
                    </h5>
                    <h5 class="card-title" style="color: black !important">
                      <strong>Placa: {{ form_update.vehicle.plate }}</strong>
                    </h5>
                  </div>
                  <div class="col-md-4">
                    <img
                      v-if="
                        form_update.user.url_image != null &&
                        form_update.user.url_image != undefined &&
                        form_update.user.url_image != '' &&
                        form_update.user.url_image != 'prueba'
                      "
                      class="card-img-top mx-auto d-block mt-2"
                      :src="form_update.user.url_image"
                      style="
                        height: 80px;
                        width: 80px;
                        text-align: center;
                        border-radius: 50px;
                      "
                    />
                    <img
                      v-else
                      class="card-img-top mx-auto d-block mt-2"
                      src="https://static.vecteezy.com/system/resources/thumbnails/008/442/086/small_2x/illustration-of-human-icon-user-symbol-icon-modern-design-on-blank-background-free-vector.jpg"
                      onerror="this.onerror=null;src=this.default_img"
                      style="
                        height: 80px;
                        width: 80px;
                        text-align: center;
                        border-radius: 50px;
                      "
                    />
                    <h4 style="color: black !important">
                      <strong
                        >{{ form_update.user.first_name }}
                        {{ form_update.user.last_name }}</strong
                      >
                    </h4>
                    <p style="color: black !important; font-size: 16px">
                      Fecha de inspección: {{ formatDate2(form_update.date) }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6">
                    <h4><strong>Resultados de la inspección:</strong></h4>

                    <ul class="list-group">
                      <li
                        class="list-group-item"
                        style="border: 1px solid; border-color: #dbdbdb"
                        v-for="(category, index) in InspectionsTmp.categories"
                        :key="index"
                      >
                        <h5 style="display: flex; align-items: center">
                          {{ category.name }}
                          <span
                            >{{
                              ": " +
                              parseFloat(category.result).toFixed(0) +
                              " / " +
                              parseFloat(category.value).toFixed(0) +
                              " "
                            }}
                          </span>
                        </h5>
                      </li>
                      <li
                        class="list-group-item"
                        style="border: 1px solid; border-color: #dbdbdb"
                      >
                        <h4>
                          <strong>Total: </strong> {{ formatAmount(InspectionsTmp.total) }}
                          <strong>/ 100</strong>
                        </h4>
                      </li>
                    </ul>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <h5>Estatus</h5>
                      <multiselect
                        track-by="id"
                        selectLabel="Seleccionar"
                        selectedLabel=""
                        deselectLabel="Remover"
                        :searchable="true"
                        v-model="form_update.type_inspection_status"
                        label="name"
                        :options="statusTmp"
                        placeholder="Seleccionar"
                        :select-label="'Seleccionar'"
                        @select="updateStatus"
                      ></multiselect>
                    </div>

                    <h5>Observaciones</h5>

                    <textarea
                      class="form-control"
                      v-model="form_update.observation"
                      style="height: 150px; width: 300px !important"
                    ></textarea>
                    <button
                      type="button"
                      class="btn btn-primary mt-3"
                      @click="saveObservation(form_update)"
                      style="
                        background: #651366 !important;
                        border-radius: 15px !important;
                        color:white;
                      "
                    >
                      Guardar observación
                    </button>


                    
                    <br>
                    <br>
                    <h3>Resultado definitivo: {{ form_update.total_result }}</h3>
                    <br>
                    <button
                      type="button"
                      class="btn btn-primary mt-3"
                      @click="closeInspection(form_update)"
                      style="
                        background: #651366 !important;
                        border-radius: 15px !important;
                        color:white;
                      "
                    >
                      Asignar resultados definitivo con {{ form_update.total }} puntos
                    </button>
                  </div>
                </div>
              </div>
            </div>
           
            
          </div>
        </div>

       
      </div>
    </div>
  </div>
</template>

<script>
function clearAccents(cadena) {
  let chars = {
    á: "a",
    é: "e",
    í: "i",
    ó: "o",
    ú: "u",
    à: "a",
    è: "e",
    ì: "i",
    ò: "o",
    ù: "u",
    ñ: "n",
    Á: "A",
    É: "E",
    Í: "I",
    Ó: "O",
    Ú: "U",
    À: "A",
    È: "E",
    Ì: "I",
    Ò: "O",
    Ù: "U",
    Ñ: "N",
  };
  let expr = /[áàéèíìóòúùñ]/gi;
  let res = cadena.replace(expr, function (e) {
    return chars[e];
  });
  return res;
}

import { mapState } from "vuex";
import { mapActions } from "vuex";
import Swal from "sweetalert2";
import "sweetalert2/src/sweetalert2.scss";
import LTable from "src/components/Table.vue";
import Card from "src/components/Cards/Card.vue";
import Multiselect from "vue-multiselect";
import moment from "moment";
import { data } from "jquery";

export default {
  components: {
    LTable,
    Card,
    Multiselect,
  },
  data() {
    return {
      //LABELS
      title: "Detalles de inspección",
      description: "Podrás gestionar a los administradores de la plataforma",
      buttonNewLabel: "Crear nueva inspección",
      buttonNewUrl: "InspectionsNew",
      buttonEditUrl: "InspectionsEdit",
      finderLabel: "Placa del vehículo",
      observation: "",
      result: "",

      statusTmp: [],
      //VARIABLE
      form_update: {
        id: 0,
        name: "",
        type_inspection_status: "",
      },
      form_updateInspections: {
        observation: "",
      },
      finder: "",
      metaInfo: {},
      sortOrder: "asc",
      // sortKey: "first_name",
      default_img: "public/img/logochami.png",
      //FILTERS
      active_model: "",
      activeTmp: [
        {
          id: 1,
          name: "Activo",
        },
        {
          id: 0,
          name: "Inactivo",
        },
      ],

      //TABLE DATA
      tableData: {
        columns: [
          {
            name: "Nombre",
            key: "name",
          },
          {
            name: "Apellido",
            key: "last_name",
          },
          {
            name: "Cédula",
            key: "dni",
          },
          {
            name: "Correo",
            key: "email",
          },
          {
            name: "Teléfono celular",
            key: "phone_1",
          },
          {
            name: "Fecha inscripción",
            key: "created_at",
          },

          {
            name: "Acciones",
            key: "actions",
          },
        ],
        data: [],
      },
      //DATA Variables
      Users: [],

      InspectionsTmp: {},

      //TABLE Buttons
      buttons: [
        {
          icon: "eye",
          icon_negative: "eye",
          type_button: "btn-info",
          tooltip: "Ver Detalles",
          url: "/admin/users/admins/edit",
          type_action: "go_url",
          action: "go_url",
          fill_icon: "#f76e2a",
          background_color: "white",
        },
        {
          icon: "check-square",
          icon_negative: "minus-square",
          type_button: "btn-warning",
          tooltip: "Cambiar Estatus",
          url: "",
          type_action: "go_method",
          action: "changeStatus",
          fill_icon: "#651366",
          background_color: "white",
        },
        {
          icon: "trash",
          icon_negative: "trash",
          type_button: "btn-danger",
          tooltip: "Eliminar administrador",
          url: "",
          type_action: "go_method",
          action: "rejectedStatus",
          fill_icon: "#8CC540",
          background_color: "white",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      me: (state) => state.auth.me,
      me_rol: (state) => state.auth.me_rol,
    }),
    sortOptions() {
      return [];
    },
    formattedDate() {
      const today = moment(); // Use moment to create a moment object
      return today.format("DD-MM-YYYY"); // Format using moment's format method
    },
    // rows() {
    //   return this.UsersTmp.length;
    // },
  },
  mounted() {
    this.getElement(this.$route.params.id);
    this.loadElements(this.$route.params.id);
    this.loadStatus();
  },
  // updated() {
  //   console.log(this.user);
  // },
  methods: {
    ...mapActions(["getData", "changeStatusData", "createData", "updateData"]),
    goBack() {
      window.history.go(-1);
    },
    formatAmount(amount){
      return parseFloat(amount).toFixed(2);
    },
    closeInspection(data) {
      // Actualiza manualmente el valor en form_update
      //sweet alert to confirm
      Swal.fire({
        title: "¿Estás seguro de actualizar la inspección con un resultado de:"+data.total+"?",
        text: "Esto guardará un resultado definitivo para la inspección",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#651366",
        cancelButtonColor: "#F76E2A",
        confirmButtonText: "Sí, actualizar inspección",
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleting = true;
      let form = {
        id: this.$route.params.id,
        url: "inspection/update",

        data: {
          total_result: data.total,
          id_type_inspection_status: this.form_update.type_inspection_status.id,
          observation: this.form_update.observation,
        },
      };
      this.updateData(form)
        .then((response) => {
          if (response.code === 200) {
            this.deleting = false;
            Swal.fire({
              title: "Estatus actualizado",
              icon: "success",
              showConfirmButton: false,
              showLoaderOnConfirm: true,
              timer: 1000,
            });
            this.getElement(this.$route.params.id);
          }
        })
        .catch((error) => {
          console.log(error);
          this.deleting = false;
        });
        }
      });
     
    },
    goNew() {
      this.$router.push({ name: this.buttonNewUrl });
    },
    goView(id) {
      this.$router.push({ path: "/admin/inspections/edit/" + id });
      console.log(id, "id del edit nuevo");
    },
    calculateMargin(name) {
      // Ajusta este valor según tus necesidades
      const baseMargin = 20;
      return Math.max(0, baseMargin - name.length);
    },
    cleanFilters() {
      this.finder = "";
      this.active_model = "";
      this.loadElements();
    },
    updateStatus(selectedOption) {
      // Actualiza manualmente el valor en form_update
      console.log("pase oir aqui", selectedOption);
      this.deleting = true;
      let form = {
        id: this.$route.params.id,
        url: "inspection/update",
        data: {
          id_type_inspection_status: (this.form_update.type_inspection_status =
            selectedOption.id),
        },
      };
      this.updateData(form)
        .then((response) => {
          if (response.code === 200) {
            this.deleting = false;
            Swal.fire({
              title: "Estatus actualizado",
              icon: "success",
              showConfirmButton: false,
              showLoaderOnConfirm: true,
              timer: 1000,
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.deleting = false;
        });
    },

    formatDate2(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    formatDate(date) {
      return moment(date).format("DD [de ]MMMM [de] YYYY"); // Ejemplo: 27 de Mayo de 2024
    },
    openModal(inspectionDetail) {
      $("#observationModal").modal("toggle");
      this.form_updateInspections = inspectionDetail;
      this.modalActiveSave = true;
    },
    loadElements(id) {
      let form = {
        url: "inspection/results/" + id,
      };
      this.isBusy = true;
      this.getData(form)
        .then((response) => {
          this.isBusy = false;
          if (response.code === 200) {
            (this.form_updateInspections = response.data),
              (this.Users = response.data);
            this.metaInfo = response.data.meta;
            this.InspectionsTmp = this.Users;
            console.log(this.UsersTmp, "Aqui estan los datos");
            console.log(this.UsersTmp.id, "id del edit");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    loadStatus() {
      let form = {
        url: "type_inspection_status/all",
        params: {
          active: 1,
        },
      };

      if (this.metaInfo.current_page > 1) {
        form.params.page = this.metaInfo.current_page;
      }

      if (this.finder != "") {
        form.params.query = this.finder;
      }
      this.isBusy = true;
      this.getData(form)
        .then((response) => {
          this.isBusy = false;
          if (response.code === 200) {
            this.statusTmp = response.data;
            console.log("status", this.statusTmp);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getElement(id) {
      this.loaded = false;
      let data_params = {
        url: "inspection/results/" + id,
        params: {
          active: 1,
          order_by: "id",
          order_key: "desc",
        },
      };
      this.getData(data_params)
        .then((response) => {
          this.form_update = response.data;

          if (this.form_update.smoke_glasses == 1) {
            this.form_update.smoke_glasses = this.smokeTMP[0];
          }
          if (this.form_update.smoke_glasses == 2) {
            this.form_update.smoke_glasses = this.smokeTMP[1];
          }
          if (this.form_update.air_conditioning == 1) {
            this.form_update.air_conditioning = this.airTMP[0];
          }
          if (this.form_update.air_conditioning == 2) {
            this.form_update.air_conditioning = this.airTMP[1];
          }
          //     this.loadSelects("master/type_brand");
          // this.loadSelects("master/type_vehicle");
          // this.loadSelects("master/type_model");
          // this.loadSelects("user");

          // const selectedTypeModel = this.typeModelTMP.find(model => model.id === this.form_update.id_type_model);
          // this.form_update.type_model = selectedTypeModel;

          // const selectedUser = this.usersTMP.find(user => user.id === this.form_update.id_user);
          // this.form_update.user = selectedUser;

          this.loaded = true;
        })
        .catch((error) => {
          this.loaded = true;
          console.log(error);
        });
    },
    changeStatus(data) {
      let active = data.active === 1 ? 0 : 1;
      let title = data.active === 1 ? "Desactivar" : "Activar";
      let title2 = data.active === 1 ? "Desactivado" : "Activado";
      let text =
        data.active === 1
          ? "¿Estás seguro de desactivarlo ahora?"
          : "¿Estás seguro de activarlo ahora?";
      Swal.fire({
        title: title,
        text: text,
        icon: "question",
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#651366",
        cancelButtonColor: "#F76E2A",
        confirmButtonText: "Cambiar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          let form = {
            id: data.id,
            url: "user/change_status",
            status: active,
          };
          this.changeStatusData(form)
            .then((response) => {
              if (response.code === 200) {
                this.loadElements();
                data.active = active;
                Swal.fire({
                  title: title2,
                  icon: "success",
                  confirmButtonColor: "#651366",
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    saveObservation(item) {
      let data_form;
      data_form = new FormData();
      data_form.append("observation", item.observation);

      let form = {
        url: "inspection/update",

        id: item.id,
        data: data_form,
      };
      this.updateData(form).then((response) => {
        if (response.code === 200) {
          this.deleting = false;
          Swal.fire({
            title: "Datos actualizados correctamente",
            icon: "success",
            showConfirmButton: false,
            showLoaderOnConfirm: true,
            timer: 1000,
          });
          // $("#observationModal").modal("hide");
          // const expires_in = moment().format("YYYY-MM-DD HH:mm");
          // const expires_at = moment(expires_in).add(4, 'hours').format("YYYY-MM-DD HH:mm");
          // const expires_at_date = new Date(expires_at);
          // Cookies.remove("id_type_user");
          // Cookies.set("id_type_user", id_type_user, { expires: expires_at_date });
          // location.reload();
          // this.loadElements(this.$route.params.id);
          // this.getElement(this.id_user_logged);
        }
      });
    },
    saveElement(Itemresult, id, idparam) {
      // Obtener el elemento input
      const inputElement = Itemresult;
      const numero = parseInt(inputElement);
      console.log(numero, "aqui esta el valor", id, idparam);
      let data_form;
      data_form = new FormData();
      data_form.append("result", numero);
      data_form.append("id_inspection", id);
      data_form.append("id_inspection_parameter", idparam);

      let form = {
        url: "inspection_detail/save",

        id: this.$route.params.id,
        data: data_form,
      };
      this.createData(form).then((response) => {
        if (response.code === 200) {
          this.deleting = false;
          Swal.fire({
            title: "Datos actualizados correctamente",
            icon: "success",
            showConfirmButton: false,
            showLoaderOnConfirm: true,
            timer: 1000,
          });

          // const expires_in = moment().format("YYYY-MM-DD HH:mm");
          // const expires_at = moment(expires_in).add(4, 'hours').format("YYYY-MM-DD HH:mm");
          // const expires_at_date = new Date(expires_at);
          // Cookies.remove("id_type_user");
          // Cookies.set("id_type_user", id_type_user, { expires: expires_at_date });

          this.loadElements();
          // this.getElement(this.id_user_logged);
        }
      });
    },
    rejectedStatus(data) {
      let title = "Eliminar administrador";

      let text = "¿Estás seguro de eliminar este administrador?";
      Swal.fire({
        title: title,
        text: text,
        icon: "question",
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#651366",
        cancelButtonColor: "#F76E2A",
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          let form = {
            id: data.id,
            url: "user/change_status",
            status: 2,
          };
          this.changeStatusData(form)
            .then((response) => {
              if (response.code === 200) {
                this.loadElements();
                // data.active = active;
                Swal.fire({
                  title: "El administrador fue eliminado",
                  icon: "success",
                });
                // location.reload();
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
  },
};
</script>

<style>
.accordion {
  border: none !important;
  padding: 0 !important;
}

.accordion-item {
  background-color: #fff !important;
  border-radius: 0 !important;
}

.accordion-header {
  background-color: #eee !important;
  border: none !important;
  box-shadow: none !important;
}

.accordion-header button {
  color: #000 !important;
  font-weight: bold !important;
}

.accordion-body {
  background-color: #fff !important;
  padding: 15px !important;
}

.accordion-item:nth-child(odd) .accordion-collapse.show,
.accordion-item:nth-child(even) .accordion-collapse.show {
  border-radius: 5px !important;
}
</style>
